export const path = {
    api: { 
        /* Please update these paths AND the API documentation: 
        https://sony.sharepoint.com/:f:/r/sites/SMP-IT/RepModProject/Shared%20Documents/Functional%20Documentation%20-%20UI/api/report?csf=1&web=1&e=ymWUmj
        */
        report: '/report',
        auth: '/report/authorization',
        datalookup: '/report/datalookup',
        user: '/report/user'
    },
    client: {}
}